import { useEffect } from 'react';
import { useBoolean } from 'usehooks-ts';
import * as faceapi from '@vladmandic/face-api';

export const useFaceDetection = () => {
	const { value: isModelsLoaded, setTrue: setModelsLoaded } = useBoolean(false);

	useEffect(() => {
		void setupFaceRecognition().then(setModelsLoaded);
	}, [setModelsLoaded]);

	return {
		loading: !isModelsLoaded,
	};
};

async function setupFaceRecognition() {
	await initializeTensorFlow();

	return loadModels();
}

function initializeTensorFlow() {
	// https://github.com/vladmandic/face-api/blob/171d17cadf208d8e307aecb64f92c2cb65ac5ba3/demo/index.js#L120

	// @ts-expect-error type error
	if (faceapi.tf?.env().flagRegistry.CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU)
		// @ts-expect-error type error
		faceapi.tf.env().set('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU', true);
	// @ts-expect-error type error
	if (faceapi.tf?.env().flagRegistry.WEBGL_EXP_CONV) faceapi.tf.env().set('WEBGL_EXP_CONV', true);
	// @ts-expect-error type error
	if (faceapi.tf?.env().flagRegistry.WEBGL_EXP_CONV) faceapi.tf.env().set('WEBGL_EXP_CONV', true);
	// @ts-expect-error type error
	faceapi.tf.enableProdMode();

	// @ts-expect-error type error
	return faceapi.tf.ready();
}

function loadModels() {
	return Promise.all(
		(['ssdMobilenetv1', 'faceLandmark68Net', 'faceRecognitionNet'] as const).map(loadModel),
	);
}

function loadModel(modelName: keyof typeof faceapi.nets) {
	const MODEL_URL = '/models';

	return faceapi.nets[modelName].load(MODEL_URL);
}
